<div class="main-container clarichat">
  <div class="top-bar d-flex justify-content-between align-items-center"></div>

  <div class="messages-container" #messagesContainer>
    <div class="pinned-nav-top-right" *ngIf="pinnedMessages.length > 0">
      <div class="pin-stack-anchor">
        <button
          class="arrow prev"
          type="button"
          (click)="scrollToPinned(false); $event.stopPropagation()"
        >
          <i class="fas fa-arrow-up"></i>
        </button>

        <button
          class="arrow next"
          type="button"
          (click)="scrollToPinned(true); $event.stopPropagation()"
        >
          <i class="fas fa-arrow-down"></i>
        </button>

        <button
          type="button"
          class="pin-stack-pill"
          aria-label="Pinned messages"
          (click)="togglePinStack($event)"
        >
          📌 {{ pinnedMessages.length }} pinned
        </button>

        <button
          type="button"
          class="pin-clear-btn"
          aria-label="Clear all pinned messages"
          (click)="clearAllPins($event)"
        >
          <i class="fas fa-xmark"></i>
        </button>

        <div class="pin-stack-preview" *ngIf="showPinStack" (click)="$event.stopPropagation()">
          <div class="pin-stack-title">📌 {{ pinnedMessages.length }} pinned</div>

          <button
            type="button"
            class="pin-stack-item"
            *ngFor="let pm of pinnedMessages; trackBy: trackMsg"
            (click)="jumpToPinned(pm.id); $event.stopPropagation()"
          >
            <div class="pin-stack-snippet">
              {{ pm.content || '[no text]' }}
            </div>
            <div class="pin-stack-meta">
              {{ pm.modelDisplayName || '' }}
              <span *ngIf="pm.timestamp">• {{ pm.timestamp | date: 'short' }}</span>
            </div>
          </button>
        </div>
      </div>
    </div>

    <div class="chat-placeholder-grid-container" *ngIf="currentMessages.length === 0 && !isRequestInProgress && !generating">
      <div class="placeholder-wrapper">
        <div class="placeholder-content">
          <img [src]="currentLogo" class="grid-item-logo vendor-logo" alt="Selected model logo" />
          <h1 class="placeholder-title">Coming Soon</h1>
          <h1 class="placeholder-subtitle bigal-sub coming-soon-subcopy">Generate World Class Videos with Veo and Eleven Labs</h1>
        </div>
      </div>
    </div>

    <ng-container *ngFor="let msg of currentMessages; let i = index; trackBy: trackMsg">
      <div
        class="message"
        [id]="'msg-' + msg.id"
        [ngClass]="{ 'user-message': msg.role === 'user', 'assistant-message': msg.role === 'assistant' }"
      >
        <button
          *ngIf="!msg.pinned"
          type="button"
          class="pin-corner-btn"
          (click)="togglePinMessage(msg)"
          [attr.aria-pressed]="msg.pinned"
          [attr.title]="msg.pinned ? 'Unpin message' : 'Pin message'"
        >
          <img src="assets/svg/pin.svg" height="25px" />
        </button>

        <button
          *ngIf="msg.pinned"
          type="button"
          class="pin-corner-btn"
          (click)="togglePinMessage(msg)"
          [attr.aria-pressed]="msg.pinned"
          [attr.title]="msg.pinned ? 'Unpin message' : 'Pin message'"
        >
          <i class="fa-thumbtack" [ngClass]="{ 'fa-solid pinned': msg.pinned }"></i>
        </button>

        <div
          *ngIf="msg.content"
          class="markdown prism-content"
          [innerHTML]="convertMarkdown(msg.content)"
          appCodeHighlight
        ></div>

        <div *ngIf="isImageMessage(msg)" class="image-result">
          <img *ngIf="msg.image" [src]="msg.image" class="image-result__item" alt="Generated image" />
          <div class="image-result__variants" *ngIf="msg.images && msg.images.length > 0">
            <img
              *ngFor="let img of msg.images"
              [src]="img"
              class="image-result__item"
              alt="Generated image variant"
            />
          </div>
        </div>

        <div *ngIf="isVideoMessage(msg)" class="video-message">
          <img *ngIf="msg.thumbnail && !msg.video" [src]="msg.thumbnail" class="video-thumb" alt="Video preview" />

          <div *ngIf="!msg.video" class="video-progress">
            <app-bird-loader label="Thinking"></app-bird-loader>
            <span *ngIf="msg.progress != null">{{ msg.progress }}%</span>
          </div>

          <video *ngIf="msg.video" [src]="msg.video" controls playsinline></video>
        </div>

        <div class="message-footer">
          <div class="message-footer-meta">
            <span class="message-timestamp">
              {{ msg.timestamp | date: 'short' }}
            </span>
            <span class="message-meta-chip" *ngIf="msg.role === 'user'">Me</span>
            <span class="message-meta-chip" *ngIf="msg.role === 'assistant' && (msg.modelDisplayName || msg.modelId)">
              {{ msg.modelDisplayName || msg.modelId }}
            </span>
          </div>

          <div class="message-footer-actions">
            <button type="button" class="message-footer-btn" (click)="onActionCopy(msg, i)">
              Copy
            </button>

            <span class="actions-anchor">
              <button class="actions-plus-btn" type="button" (click)="toggleActionsMenu(msg, $event)">
                +
              </button>

              <div class="actions-dropdown anchored" *ngIf="isActionsMenuOpen(msg)" (click)="$event.stopPropagation()">
                <button type="button" class="actions-item" (click)="onActionPin(msg)">
                  <span class="me-2">{{ msg.pinned ? '📌' : '🔖' }}</span>
                  {{ msg.pinned ? 'Unpin' : 'Pin' }}
                </button>

                <button type="button" class="actions-item" (click)="onActionCopyToClariChat(msg)">
                  <i class="fa-solid fa-arrow-up-right-from-square me-2"></i>
                  Add to ClariNotes
                </button>
              </div>

              <span
                class="action-toast anchored"
                *ngIf="msg?.id && actionToastById[msg.id]"
                [ngClass]="actionToastById[msg.id].type"
              >
                {{ actionToastById[msg.id].text }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </ng-container>

    <app-bird-loader
      *ngIf="isRequestInProgress && !isVideoComposerModel"
      [label]="thinkingLoaderLabel"
    ></app-bird-loader>
  </div>

  <div class="bottomcontainer">
    <div class="input-container">
      <button
        class="scroll-to-bottom-btn"
        *ngIf="showScrollToBottom"
        (click)="scrollToBottom()"
        aria-label="Scroll to bottom"
      >
        ↓
      </button>

      <div class="composer-shell">
        <div class="textarea-wrapper">
          <input
            #referenceImageInput
            id="imageReferenceUpload"
            type="file"
            [accept]="imageAccept || 'image/*'"
            (change)="onFileSelected($event)"
            style="display: none"
          />
          <div class="composer-attachment-preview" *ngIf="referencePreviewUrl">
            <img [src]="referencePreviewUrl" alt="Attached reference image" />
            <button type="button" (click)="clearImage()" aria-label="Remove attached image">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <textarea
            #videoTextarea
            id="videoPromptInput"
            class="user-input-textarea"
            [(ngModel)]="userInput"
            rows="1"
            [placeholder]="composerPlaceholder"
            (keydown)="onKeyDown($event)"
            (input)="autoResize(videoTextarea)"
            [disabled]="audioActive || isRequestInProgress"
            [class.disabled-typing]="audioActive"
          ></textarea>

          <div class="left-actions">
            <div class="composer-tools">
              <button
                type="button"
                class="tools-plus-btn"
                aria-label="Select media model"
                (click)="openMediaModelDialog($event)"
              >
                <span class="tools-plus-icon" aria-hidden="true">+</span>
              </button>

            </div>
          </div>

          <!-- <button
            id="micButton"
            class="btn-audio-fixed"
            type="button"
            (click)="onAudioIconClick()"
            matTooltip="Click to start voice"
          >
            <img src="assets/icons/audio-wave.svg" class="audio-icon" alt="Audio" />
          </button> -->

          <div class="reference-error" *ngIf="imageValidationError">{{ imageValidationError }}</div>
          <div class="reference-error" *ngIf="error">{{ error }}</div>

          <button
            id="generateMediaButton"
            class="btn-send-fixed"
            type="button"
            (click)="sendMessage()"
            [disabled]="isRequestInProgress || !canSubmit"
          >
            <i class="fas fa-arrow-up send-arrow-icon" aria-hidden="true"></i>
          </button>

          <div class="model-grid-inside">
            <div class="grid-item-inside selector video-dropdown-root">
              <button
                type="button"
                id="mediaModelDropdown"
                class="composer-model-name model-name-dropdown-trigger"
                (click)="openMediaModelDialog($event)"
                aria-haspopup="dialog"
              >
                {{ selectedModelName }}
                <i class="fa-solid fa-chevron-down"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="video-controls" *ngIf="generating">
      <div class="genbar">
        <div class="genrow">
          <span class="videoIcon flashing">🎥</span>
          <span class="genText">Generating with {{ selectedModelName }}…</span>
          <span class="pct">{{ uiProgressRounded }}%</span>
        </div>
        <div class="bar">
          <div class="fill" [style.width.%]="uiProgress"></div>
        </div>
      </div>
    </div>
  </div>
</div>
